<template lang="pug">
  .title(:class="classArray()")
    <!-- @slot Use this slot for header content -->
    slot
</template>

<script>
import { semiBoldMixin } from "@/mixins/textWeightMixin";

const SIZES = ["h1", "h2", "h3", "h4", "h5", "h6"];
const CARD_TITLE_SIZE = "h5";
const CARD_TITLE_LARGE_SIZE = "h3";

export default {
  name: "WtTitle",

  mixins: [semiBoldMixin],

  props: {
    /**
     * `h1, h2, h3, h4, h5, h6`
     */
    size: {
      type: String,
      validator(size) {
        return SIZES.indexOf(size) !== -1;
      },
      default: "h5"
    },

    /**
     * Currently, we only need to support a green header,
     * in the event we need more flexibility this
     * prop should be renamed to 'color'
     */
    green: Boolean,

    /**
     * shortcut for creating an h5 semibold header
     */
    cardTitle: Boolean,
    /**
     * shortcut for creating an h3 semibold header
     */
    cardTitleLarge: Boolean
  },

  methods: {
    classArray() {
      return [
        this.titleClass(),
        this.colorClass(),
        this.semiboldClass({ ignoreProp: this.cardTitle })
      ];
    },

    titleClass() {
      let size = this.size[1];
      const sizeAsAttrArr = Object.keys(this.$attrs);

      if (this.cardTitle) {
        size = CARD_TITLE_SIZE[1];
      } else if (this.cardTitleLarge) {
        size = CARD_TITLE_LARGE_SIZE[1];
      } else {
        sizeAsAttrArr.forEach((attr, index) => {
          if (SIZES.indexOf(attr) !== -1) {
            size = sizeAsAttrArr[index][1];
          }
        });
      }

      return `is-${size}`;
    },

    colorClass() {
      return this.green ? "has-text-green" : "";
    }
  }
};
</script>

<style lang="sass"></style>
